module.exports = __webpack_public_path__ + "13850f121635b463a2884d43e5007574.svg";